const LINKS = [
  { label: "Products", href: "#products" },
  { label: "Materials & Grades", href: "#grades" },
  { label: "Industries", href: "#industries" },
  { label: "Bolting Calculator", href: "#calculator" },
  { label: "Why Choose Us", href: "#why-us" },
  { label: "Certifications", href: "#certifications" },
  { label: "Registrations", href: "#credentials" },
  { label: "Clients", href: "#clients" },
  { label: "About Us", href: "#about" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="bg-ink text-slate-400 border-t border-slate-800" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src="/rew-logo.png"
              alt="Rahil Engineering Works"
              className="h-16 w-auto brightness-0 invert opacity-90"
            />
            <span className="font-display font-black text-2xl sm:text-3xl uppercase tracking-wide text-white border-l border-slate-700 pl-4 leading-tight">
              Rahil Engineering Works
            </span>
          </div>
          <p className="text-sm leading-relaxed max-w-xs">
            Precision stud nuts, stud bolts, hex bolts, threaded rods, washers
            and custom machined components — ISO 9001:2015 certified,
            manufactured in Vadodara since 2007.
          </p>
        </div>

        <div>
          <div className="font-sans font-medium text-[11px] tracking-[0.12em] uppercase text-brand mb-4">
            Navigate
          </div>
          <ul className="space-y-2.5">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="font-sans font-medium text-xs uppercase tracking-[0.12em] hover:text-brand transition-colors duration-200"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="font-sans font-medium text-[11px] tracking-[0.12em] uppercase text-brand mb-4">
            Reach us
          </div>
          <ul className="space-y-2.5 text-sm">
            <li>303/22 Makarpura GIDC, Vadodara, Gujarat</li>
            <li>
              <a href="tel:+918000151777" className="hover:text-brand transition-colors" data-testid="footer-phone-link">
                Manish R Shah — 8000151777 / 9375267221
              </a>
            </li>
            <li>
              <a href="tel:+918905853080" className="hover:text-brand transition-colors" data-testid="footer-phone-link-2">
                Rahil Shah — 8905853080
              </a>
            </li>
            <li>
              <a href="mailto:sales@rahilengineering.com" className="hover:text-brand transition-colors" data-testid="footer-email-link">
                sales@rahilengineering.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="font-sans font-medium text-[11px] tracking-[0.14em] uppercase">
            © 2026 Rahil Engineering Works. All rights reserved.
          </p>
          <p className="font-sans font-medium text-[11px] tracking-[0.14em] uppercase text-slate-500">
            ISO 9001:2015 Certified Company · Est. 2007
          </p>
        </div>
      </div>
    </footer>
  );
}
